import { forwardRef } from "react";
import { FormControl, FormErrorMessage, FormLabel } from "@chakra-ui/react";
import { Props } from "chakra-react-select";
import useGetProductList from "hooks/api/products/useGetProductList";
import { Select } from "components/Select";

export type ProductSelectProps = { id: string };

const ProductSelect = forwardRef<
  any,
  Props & { errorMsg?: string | undefined }
>(({ id = "", errorMsg, ...rest }, ref) => {
  const { data: productOptions, isLoading } = useGetProductList();

  return (
    <FormControl
      isInvalid={!!errorMsg}
      isDisabled={isLoading || productOptions?.length === 0}
      id={id}
    >
      <FormLabel>Product</FormLabel>
      <Select
        ref={ref}
        placeholder="Select product"
        options={productOptions}
        isLoading={isLoading}
        {...rest}
      />
      <FormErrorMessage>{errorMsg}</FormErrorMessage>
    </FormControl>
  );
});

ProductSelect.displayName = "ProductSelect";

export default ProductSelect;
